export enum TipoDeDespesa {
  JUROS_PAGOS = 'JUROS_PAGOS',
  MULTAS_PAGAS = 'MULTAS_PAGAS',
  COMPRAS_DE_MERCADORIAS = 'COMPRAS_DE_MERCADORIAS',
  SALARIOS = 'SALARIOS',
  INTERNET = 'INTERNET',
  TELEFONE = 'TELEFONE',
  ENERGIA_ELETRICA = 'ENERGIA_ELETRICA',
  AGUA = 'AGUA',
  ALUGUEL = 'ALUGUEL',
  MANUTENCAO_DO_PREDIO = 'MANUTENCAO_DO_PREDIO',
  MANUTENCAO_DE_EQUIPAMENTOS = 'MANUTENCAO_DE_EQUIPAMENTOS',
  MANUTENCAO_DE_VEICULOS = 'MANUTENCAO_DE_VEICULOS',
  SEGURO_DO_PREDIO = 'SEGURO_DO_PREDIO',
  SEGURO_DE_VEICULOS = 'SEGURO_DE_VEICULOS',
  PUBLICIDADE = 'PUBLICIDADE',
  PUBLICIDADE_ONLINE = 'PUBLICIDADE_ONLINE',
  HORAS_EXTRAS = 'HORAS_EXTRAS',
  DECIMO_TERCEIRO = 'DECIMO_TERCEIRO',
  FERIAS = 'FERIAS',
  VALE_TRANSPORTE = 'VALE_TRANSPORTE',
  VALE_ALIMENTACAO = 'VALE_ALIMENTACAO',
  VIATICO = 'VIATICO',
  COMISSOES_DE_VENDAS = 'COMISSOES_DE_VENDAS',
  DOACOES = 'DOACOES',
  BONIFICACOES = 'BONIFICACOES',
  ENVIO_DE_MERCADORIAS = 'ENVIO_DE_MERCADORIAS',
  PLANO_DE_SAUDE = 'PLANO_DE_SAUDE',
  AVISO_PREVIO = 'AVISO_PREVIO',
  INDENIZACAO_LABORAL = 'INDENIZACAO_LABORAL',
  PRESENTES = 'PRESENTES',
  ALUGUEL_DE_SISTEMAS = 'ALUGUEL_DE_SISTEMAS',
  COMBUSTIVEL = 'COMBUSTIVEL',
  CONTADOR = 'CONTADOR',
  HONORARIOS_PROFISSIONAIS = 'HONORARIOS_PROFISSIONAIS',
  DESPESAS_BANCARIAS = 'DESPESAS_BANCARIAS',
  PEDAGIOS = 'PEDAGIOS',
  FOTOCOPIAS_E_IMPRESSOES = 'FOTOCOPIAS_E_IMPRESSOES',
  MATERIAL_DE_LIMPEZA = 'MATERIAL_DE_LIMPEZA',
  FEIRAS_CONGRESSOS_E_EVENTOS = 'FEIRAS_CONGRESSOS_E_EVENTOS',
  CURSOS_E_TREINAMENTOS = 'CURSOS_E_TREINAMENTOS',
  CONFRATERNIZACOES = 'CONFRATERNIZACOES',
  IMPOSTOS = 'IMPOSTOS',
  COMPRAS_ATIVO_IMOBILIZADO = 'COMPRAS_ATIVO_IMOBILIZADO',
  DEVOLUCAO_DE_VENDA = 'DEVOLUCAO_DE_VENDA',
  OUTROS = 'OUTROS',
  // Novos tipos sincronizados com backend (alinhamento-despesas)
  PATROCINIOS = 'PATROCINIOS',
  JUROS_DE_CARTAO = 'JUROS_DE_CARTAO',
  COLETA_DE_LIXO = 'COLETA_DE_LIXO',
  ALUGUEL_COMERCIAL = 'ALUGUEL_COMERCIAL',
  DESCONTOS_CONCEDIDOS = 'DESCONTOS_CONCEDIDOS',
  CUSTOS_DE_SERVICOS = 'CUSTOS_DE_SERVICOS',
  FALTANTE_DE_CAIXA = 'FALTANTE_DE_CAIXA',
  MERCADO = 'MERCADO',
  FERRAMENTAS = 'FERRAMENTAS',
  PERDAS_COM_INVENTARIOS = 'PERDAS_COM_INVENTARIOS',
  MATERIAIS_DE_ESCRITORIO = 'MATERIAIS_DE_ESCRITORIO',
  COMISSOES_PAGAS = 'COMISSOES_PAGAS',
  IPS_PAGOS = 'IPS_PAGOS',
  IVA_GENERAL = 'IVA_GENERAL',
  PATENTE_COMERCIAL = 'PATENTE_COMERCIAL',
  RETENCOES_DE_IVA = 'RETENCOES_DE_IVA',
  GRAFICA_E_IMPRESSOS = 'GRAFICA_E_IMPRESSOS',
  UNIFORMES_E_EPIS = 'UNIFORMES_E_EPIS',
  MEDICAMENTOS = 'MEDICAMENTOS',
  ADIANTAMENTOS = 'ADIANTAMENTOS',
  LIMPEZA_DE_VEICULOS = 'LIMPEZA_DE_VEICULOS',
  DESPESAS_COM_SEGURANCA = 'DESPESAS_COM_SEGURANCA',
  CONSUMIVEIS = 'CONSUMIVEIS',
  HOSPEDAGEM = 'HOSPEDAGEM',
  DIFERENCA_DE_CAMBIO = 'DIFERENCA_DE_CAMBIO',
  CAFE_E_FILTROS = 'CAFE_E_FILTROS',
  BOLSAS_E_EMBALAGENS = 'BOLSAS_E_EMBALAGENS',
  PERDAS_MERCADORIAS_VENCIDAS = 'PERDAS_MERCADORIAS_VENCIDAS',
  PERDAS_DOCUMENTOS_INCOBRAVEIS = 'PERDAS_DOCUMENTOS_INCOBRAVEIS',
  BRINDES_PRESENTES = 'BRINDES_PRESENTES',
  PRO_LABORE = 'PRO_LABORE',
  OUTROS_IMPOSTOS = 'OUTROS_IMPOSTOS',
  MEDICINA_DO_TRABALHO = 'MEDICINA_DO_TRABALHO',
  DIARIAS_PAGAS = 'DIARIAS_PAGAS',
  TROCO_CONCEDIDO = 'TROCO_CONCEDIDO',
  SAIDA_TRANSFERENCIA_DE_VALORES = 'SAIDA_TRANSFERENCIA_DE_VALORES',
  // Tipos com exibir=false (nao devem aparecer no dropdown)
  CUSTO_DE_MERCADORIA_VENDIDA = 'CUSTO_DE_MERCADORIA_VENDIDA',
  SALDO_INICIAL = 'SALDO_INICIAL',
  /** Adiantamento do contador na despesa acessoria. Gerado so pelo backend. */
  ADIANTAMENTO_A_CLIENTE = 'ADIANTAMENTO_A_CLIENTE',
}

/** Tipos que NAO devem ser exibidos no dropdown (exibir=false no backend) */
export const TIPOS_DESPESA_NAO_EXIBIR: TipoDeDespesa[] = [
  TipoDeDespesa.CUSTO_DE_MERCADORIA_VENDIDA,
  TipoDeDespesa.SALDO_INICIAL,
  TipoDeDespesa.ADIANTAMENTO_A_CLIENTE,
];
